export default {
  capitaliseParameters: function (params) {
    params.sellingCompanyCode = params.sellingCompanyCode.toUpperCase()
    params.tourCode = params.tourCode.toUpperCase()
    params.departureCode =
      params.departureCode.substring(0, params.departureCode.length - 1).toUpperCase() +
      params.departureCode.substring(params.departureCode.length - 1).toLowerCase()
    return params
  },
}
